<template>

  <div class="login-container">
    <el-form class="login-form" autoComplete="on" :model="loginForm" :rules="loginRules" ref="form" label-position="left" v-if="!resetMode" >
      <h3 class="title">重设密码</h3>
      <el-form-item prop="password">
        <span class="svg-container">
          <svg-icon icon-class="password"></svg-icon>
        </span>
        <el-input name="password" :type="pwdType" @keyup.enter.native="handleReset" v-model="loginForm.password" autoComplete="on"
          placeholder="请输入密码"></el-input>
          <span class="show-pwd" @click="showPwd">
            <svg-icon icon-class="eye"  v-if="visiblePwd"/>
            <svg-icon icon-class="openeye" v-else/>
          </span>
      </el-form-item>
      <el-form-item prop="password2">
        <span class="svg-container">
          <svg-icon icon-class="password"></svg-icon>
        </span>
        <el-input name="password" :type="pwdType" @keyup.enter.native="handleReset" v-model="loginForm.password2" autoComplete="on"
          placeholder="请再次输入相同的密码"></el-input>
          <span class="show-pwd" @click="showPwd">
            <svg-icon icon-class="eye"  v-if="visiblePwd"/>
            <svg-icon icon-class="openeye" v-else/>
          </span>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" style="width:100%;" :loading="loading" @click.native.prevent="handleReset">
          重设密码
        </el-button>
      </el-form-item>
    </el-form>

    <div class="tips">
      <span>&copy;2018 广东力源工程技术有限公司 版权所有 0.45</span>
      <!-- <span>&copy;2018 成都星云联动科技有限公司 版权所有 0.45</span> -->
    </div>

  </div>
</template>

<script>
import { resetPassword } from '@/api/auth-controller/index.js'

export default {
  name: 'login',
  data () {
    const validateNewPwd = (rule, value, callback) => {
      if (value) {
        if (this.loginForm.password !== '') {
          this.$refs.form.validateField('password2')
        }
        callback()
      } else {
        callback(new Error('请输入密码'))
      }
    }
    const validateVerifyPwd = (rule, value, callback) => {
      if (value !== this.loginForm.password) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      resetMode: false,
      loginForm: {
        password: '',
        password2: ''
      },
      resetForm: {
        userEmail: ''
      },
      loginRules: {
        password: [
          { required: true, trigger: 'blur', message: '请输入密码' },
          { validator: validateNewPwd, trigger: 'blur' },
          { min: 8, max: 20, message: '密码不能小于8位，大于20位', trigger: 'blur' }
        ],
        password2: [
          { required: true, trigger: 'blur', message: '请再次输入相同的密码' },
          { validator: validateVerifyPwd, trigger: 'blur' },
          { min: 8, max: 20, message: '密码不能小于8位，大于20位', trigger: 'blur' }
        ]
      },
      loading: false,
      pwdType: 'password',
      visiblePwd: true
    }
  },
  methods: {
    showPwd () {
      if (this.pwdType === 'password') {
        this.pwdType = ''
        this.visiblePwd = !this.visiblePwd
      } else {
        this.pwdType = 'password'
        this.visiblePwd = !this.visiblePwd
      }
    },
    handleReset () {
      this.$refs.form.validate(valid => {
        if (valid) {
          resetPassword(this.$route.query.resetToken, this.loginForm.password).then(res => {
            this.$message({
              type: 'success',
              message: '重设密码成功，请登录'
            })
            this.$router.push({ path: 'login' })
          })
        }
      })
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
$bg:#2d3a4b;
$light_gray:#eee;

/* reset element-ui css */
.login-container {
  .el-input {
    display: inline-block;
    height: 47px;
    width: 85%;
    input {
      background: transparent;
      border: 0px;
      -webkit-appearance: none;
      border-radius: 0px;
      padding: 12px 5px 12px 15px;
      color: $light_gray;
      height: 47px;
      &:-webkit-autofill {
        -webkit-box-shadow: 0 0 0px 1000px $bg inset !important;
        -webkit-text-fill-color: #fff !important;
      }
    }
  }
  .el-form-item {
    border: 1px solid rgba(255, 255, 255, 0.1);
    background: rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    color: #454545;
  }
}

</style>

<style rel="stylesheet/scss" lang="scss" scoped>
$bg:#2d3a4b;
$dark_gray:#889aa4;
$light_gray:#eee;
.login-container {
  position: fixed;
  height: 100%;
  width: 100%;
  background-color: $bg;
  .login-form {
    position: absolute;
    left: 0;
    right: 0;
    width: 520px;
    padding: 35px 35px 15px 35px;
    margin: 120px auto;
  }
  .reset-link {
    float: right;
    a {
      font-size: 14px;
    }
  }
  .tips {
    display: flex;
    width: 100%;
    position: absolute;
    bottom: 1rem;
    font-size: 14px;
    color: #c0c4cc;
    span {
      &:first-of-type {
        margin: auto;
      }
    }
  }
  .svg-container {
    padding: 6px 5px 6px 15px;
    color: $dark_gray;
    vertical-align: middle;
    width: 30px;
    display: inline-block;
    &_login {
      font-size: 20px;
    }
  }
  .title {
    font-size: 26px;
    font-weight: 400;
    color: $light_gray;
    margin: 0px auto 40px auto;
    text-align: center;
    font-weight: bold;
  }
  .show-pwd {
    position: absolute;
    right: 10px;
    top: 7px;
    font-size: 16px;
    color: $dark_gray;
    cursor: pointer;
    user-select: none;
  }
}
</style>
